<template>
    <div class="pdf-preview-skeleton">
        <primevue-skeleton width="100%" height="100%" />
    </div>
</template>

<script setup lang="ts">
import PrimevueSkeleton from 'primevue/skeleton';
</script>

<style scoped lang="scss">
.pdf-preview-skeleton {
    position: absolute;
    inset: 0;
    display: block;
    z-index: 1;
}
</style>
